// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'
import getLegacyRadioCodeForModulation from './getLegacyRadioCodeForModulation'
import getRadioModulationData from './getRadioModulationData'
import { formatModulationDataForForm } from '../../helpers'
import { castToFloat } from 'helpers/reduxFormFunctions'
import assignModulationDetailsErrorsFromRadioDetails from '../assignModulationDetailsErrorsFromRadioDetails'

const getModulationDetails = (formName, radioModulationId, modulationDetailsFormName) => async (dispatch, getState) => {
  const radioData = getState().form[formName].values

  const {
    // radio code from redux-form, not from databaseDetail's initialValues object
    // this is because user can create modulations before radios are stored in DB.
    radioCode,
    // radioTypeId will be used to determine validation rules for legacyRadioCode
    radioTypeId,
  } = radioData

  const {
    modulationData,
    modulationDataIsFromState,
  } = dispatch(getRadioModulationData(radioModulationId))

  const validateLegacyRadioCode = (
    // we only validate the legacyRadioCode input field if
    // we working with a digital radio and the modulation in question
    // does not have a radioModulationId.
    // NOTE - we castToFloat here because if the radioModulationId is from state and still returns null
    // that means it has been stored in redux but the user has not yet saved the radio.
    // for this scenario we want to allow the user to update the legacyRadioCode still
    // in case they want make a last-minute change before they save to db and can no longer edit.
    // the fake id will be of the following pattern: `temp-modulation-id-${Date.now()}`
    // See formatModulationData.js for where this is created.
    castToFloat(modulationData.radioModulationId) === null &&

    // AND if the radio is not an analog radio
    // NOTE - radioTypeId of 1 hard coded here as 'Analog'
    radioTypeId !== '1'
  )

  // if we are supposed to validate the legacyRadioCode field and
  // this is a new modulation, then we want to generate a Legacy Radio Code
  // for the user so that it's auto populated for them on create.
  if (validateLegacyRadioCode && modulationDataIsFromState === false) {
    modulationData.legacyRadioCode = await dispatch(getLegacyRadioCodeForModulation(radioData))
  }

  await dispatch(initialize(modulationDetailsFormName, {
    ...dispatch(formatModulationDataForForm(modulationData)),
    // Radio Code here is for display in the heading of the Modulation Details drawer.
    radioCode,
    validateLegacyRadioCode,
  }))

  return dispatch(assignModulationDetailsErrorsFromRadioDetails(modulationDetailsFormName, modulationData))
}

export default getModulationDetails
